<fgb-banner [pageTitle]="'earn.page.title' | translate" />

<fgb-page-header [pageTitle]="'earn.page.title'" [showBalance]="false" [backButtonLink]="'/'"></fgb-page-header>

<div class="container">
  <fgbcl-earn-points [svgColor]="'primary'"></fgbcl-earn-points>
</div>
